import { supabase } from "@/integrations/supabase/client";

// F2/T1 (extraído do QuickProductDialog; I.151 1b3-b: caminho único com os assistentes de nota).
// Resolve o id pela SIGLA da nota contra o vocabulário ATIVO do tenant: (1)
// measurement_units.sefaz_code (case-insensitive); (2) fallback unit_aliases (apelidos do
// tenant: 'UN.', 'UNID', 'PEÇ'…), só se a unidade apontada estiver ativa. Sem casar → null.
export async function resolveMeasurementUnitId(
  companyId: string | null | undefined,
  rawSigla: string | null | undefined
): Promise<string | null> {
  const sigla = (rawSigla ?? "").trim().toUpperCase();
  if (!sigla || !companyId) return null;

  const { data: porSefaz } = await supabase
    .from("measurement_units")
    .select("id")
    .eq("company_id", companyId)
    .eq("active", true)
    .ilike("sefaz_code", sigla.replace(/[%_\\]/g, "\\$&"))
    .order("name")
    .limit(1)
    .maybeSingle();
  if (porSefaz?.id) return porSefaz.id;

  const { data: alias } = await (supabase as any)
    .from("unit_aliases")
    .select("measurement_unit_id")
    .eq("company_id", companyId)
    .eq("alias", sigla)
    .maybeSingle();
  if (!alias?.measurement_unit_id) return null;

  const { data: porAlias } = await supabase
    .from("measurement_units")
    .select("id")
    .eq("id", alias.measurement_unit_id)
    .eq("company_id", companyId)
    .eq("active", true)
    .maybeSingle();
  return porAlias?.id ?? null;
}
